<app-fire-foresight-menu></app-fire-foresight-menu>

<!-- BEGIN #content -->
<div id="content" class="app-content">

<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a>Fire Foresight</a>
      </li>
      <li class="breadcrumb-item">
        <a>Incidents</a>
      </li>
    </ol>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <!--<div class="row gx-4 mt-2">
    <div class="col-lg-2 col-md-3 col-sm-2 mt-2" *ngFor="let status of fire.statusTypes">
      <button [routerLink]="['/fire-foresight/incidents-watch/', status.statusId]" class="btn btn-block btn-outline-default">{{status.displayName}}</button>
    </div>
  </div>
  <div class="row gx-4 mt-4">
    <h3>Statistics - Last 20 Days</h3>
    <div class="col-lg-3" *ngFor="let stat of stats | keyvalue">
      <div class="card mb-3 bg-emphasis bg-opacity-25">

        <div class="card-body" *ngIf="stat.value">

          <div class="d-flex fw-bold small mb-3">
            <span class="flex-grow-1">{{stat.value.name}}</span>
          </div>


          <div class="row align-items-center mb-2">
            <div class="col-7">
              <h3 class="mb-0">{{stat.value.value}}</h3>
            </div>
            <div class="col-5" >
              <ngx-trend [data]="stat.value.history" padding="0" autoDraw="true" strokeWidth="4"
                autoDrawDuration="1000"  [gradient]="['#3cd2a5']"
                autoDrawEasing="ease-in"></ngx-trend>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>-->
  <div class="row" *ngFor="let status of fire.statusTypes">
    <ng-container *ngIf="status.visible"> 
    <div class="col-12">
      {{status.displayName}}
    </div>
    <div [routerLink]="'/fire-foresight/incident/' + incident.incidentId" class="col-lg-4 col-md-2 col-sm-12" *ngFor="let incident of fire.incidents | incidentpipe:status.statusId">
      <div class="card mb-4 bg-emphasis bg-opacity-25">
        <div class="card-header">
          <div class="flex-fill px-3 flex-nowrap">
            <div class="fw-bold no-wrap">
              <span class="small text-inverse text-opacity-50">#{{incident.incidentId}}</span>
              <span class=""> {{incident.site.name}}</span>
            </div>
            <div class="small text-inverse text-opacity-50">{{incident.fireIncidentDate | relativeDate}}</div>
          </div>
        </div>
        <div class="card-body p-0">
          <smart-image [showMetaData]="true" [src]="incident.firstImageUrl" ></smart-image>
        </div>
      </div>
    </div>
    </ng-container>
  </div>
</div>

</div>